import { useLoggedUser } from '@btime/react-session'
import React from 'react'

import { ASSIGN_OPTIONS, TO_ME } from '../_constants/assignConstants'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import TagPicker from '../../../../components/form/TagPicker'

const AssignPicker = () => {
  const { handleChange } = useFormState()
  const form = useForm()
  const user = useLoggedUser()

  return (
    <TagPicker
      options={ASSIGN_OPTIONS}
      onChange={value => {
        if (value === TO_ME) {
          handleChange('userOrGroup', user)
        } else {
          handleChange('userOrGroup', null)
        }
        handleChange('assign', value)
      }}
      value={form.assign}
      useMarker
    />
  )
}

export default AssignPicker
